import axios from 'axios';

import { WP_URL } from '../components/Common/const';
import endPointActivityResponse from '../components/Dashboard/Activity/activityData.json';
import endPointBadgesResponse from '../components/Dashboard/Badges/badges.json';
import endPointMyStatsResponse from '../components/Dashboard/MyStats/myStatsData.json';
import endPointRecomendedTopic from '../components/Dashboard/RecomendedTopics/recomendedTopics.json';
import endPointResource from '../components/Dashboard/ResourcesForYou/featuredResources.json';

const BASE_URL = process.env.REACT_APP_BASE_URL;

// for dashboard header
export function getDashboardHeaderInfo() {
  return axios
    .get(`${BASE_URL}/getDashboardHeaderInfo`)
    .then(({ data }) => data);
}

// for MyStats
export function getStats() {
  return endPointMyStatsResponse.myStats;
}

export function getPointsThisWeek() {
  return axios.get(`${BASE_URL}/getPointsThisWeek`).then(({ data }) => data);
}

// for Activity
export function getActivity(timePeriod) {
  switch (timePeriod) {
    case 'thisWeek':
      return endPointActivityResponse.thisWeek.activityData;
    case 'today':
      return endPointActivityResponse.today.activityData;
    case 'thisMonth':
      return endPointActivityResponse.thisMonth.activityData;
    case 'allTime':
      return endPointActivityResponse.allTime.activityData;
    default:
      return endPointActivityResponse.thisWeek.activityData;
  }
}

// for Leaderboard

export function getFriendLeaderboard(timePeriod) {
  return axios
    .post(`${BASE_URL}/getLeaderboardData`, {
      timePeriod,
      type: 'friends',
    })
    .then(({ data }) => data);
}

export function getEveryoneLeaderboard(timePeriod) {
  return axios
    .post(`${BASE_URL}/getLeaderboardData`, {
      timePeriod,
      type: 'everyone',
    })
    .then(({ data }) => data);
}

// for scoring history
export function getScoringHistoryService(startDate) {
  return axios
    .post(`${BASE_URL}/getScoringHistoryData`, { startDate })
    .then(({ data }) => data);
}

export function getBadgesService(skip, limit) {
  const badges = [];
  let i = 0;
  while (endPointBadgesResponse.badges[i] && i - skip < limit) {
    badges.push(endPointBadgesResponse.badges[i]);
    i++;
  }

  const response = {
    wonBadges: endPointBadgesResponse.wonBadges,
    maxBadges: endPointBadgesResponse.maxBadges,
    badges,
  };
  return response;
  // return axios
  //   .post(`${BASE_URL}/answerQuestion/${answer.questionId}`, answer)
  //   .then(({ data }) => data);
}

export function getDailyQuizHistoryService(skip, limit) {
  return axios
    .post(`${BASE_URL}/getDailyQuizHistory`, { skip, limit })
    .then(({ data }) => data);
}

export function getQualDailyQuizHistoryService(skip, limit) {
  return axios
    .post(
      `${BASE_URL}/getQualDailyQuizHistory?skip=${skip || 0}&limit=${
        limit || 3
      }`,
    )
    .then(({ data }) => data);
}

export function getOneDailyQuizHistoryService(id, isLastQuiz = false) {
  return axios
    .post(`${BASE_URL}/getOneDailyQuizHistory`, {
      id,
      lastQuiz: isLastQuiz,
    })
    .then(({ data }) => data);
}

export function getOneQualDailyQuizHistoryService(id, isLastQuiz = false) {
  return axios
    .post(`${BASE_URL}/getOneQualDailyQuizHistory/${id}`, {
      lastQuiz: isLastQuiz,
    })
    .then(({ data }) => data);
}

export function getCustomPracticeExamHistoryService() {
  return axios
    .post(`${BASE_URL}/getCustomPracticeExamHistory`)
    .then(({ data }) => data);
}

export function getRecomendedTopicsService(answer) {
  return endPointRecomendedTopic.recomendedTopics;
  // return axios
  //   .post(`${BASE_URL}/answerQuestion/${answer.questionId}`, answer)
  //   .then(({ data }) => data);
}

export function getFeaturedBlogService(answer) {
  return axios
    .get(`${WP_URL}posts/?_embed&page=1&per_page=1&order=desc`)
    .then(({ data }) => data);
}

export function getFeaturedPodcastService(answer) {
  return endPointResource.featuredPodcast;
  // return axios
  //   .post(`${BASE_URL}/answerQuestion/${answer.questionId}`, answer)
  //   .then(({ data }) => data);
}

export function getFeaturedForumService(answer) {
  return endPointResource.featuredForum;
  // return axios
  //   .post(`${BASE_URL}/answerQuestion/${answer.questionId}`, answer)
  //   .then(({ data }) => data);
}

export function getInviteAFriendService(answer) {
  return 0;
  // return axios
  //   .post(`${BASE_URL}/answerQuestion/${answer.questionId}`, answer)
  //   .then(({ data }) => data);
}

export function setUserCycle(cycleId) {
  return axios
    .post(`${BASE_URL}/setUserCycle`, { cycleId })
    .then(({ data }) => data);
}
